jQuery(function () {
    function setCampaignToAdded(campaignElement) {
        campaignElement.addClass('campaign--mail-on-the-way');
    }
    function setCampaignToFailed(campaignElement) {
        campaignElement.addClass('campaign--failed');
        campaignElement.addClass('interest-collection--failed');
    }
    function setInterestCollectionToAdded(campaignElement) {
        campaignElement.addClass('interest-collection--registration');
    }
    function registerCampaignForUser(campaignId, campaignElement) {
        $.ajax({
            url: '/kampanjer/register',
            method: 'POST',
            data: { id: campaignId }
        }).done(function (response) {
            location.reload();
        }).fail(function (response) {
            // TODO: What to do when fail?
            setCampaignToFailed(campaignElement);
        });
    }
    function sendCampaignToDataLayer(campaignId, campaignName) {
        window['dataLayer'].push({ 'event': 'campaignClicked', 'campaignId': campaignId, 'campaignName': campaignName });
    }
    $('.campaign__button').one('click', function (e) {
        e.preventDefault();
        var currentReadMore = $(e.target);
        var campaignId = Number(currentReadMore.attr('data-id'));
        var campaignName = currentReadMore.attr('data-name');
        var getCurrentCampaignElement = $('#campaign-base-' + campaignId);
        if (!isNaN(campaignId)) {
            setCampaignToAdded(getCurrentCampaignElement);
            registerCampaignForUser(campaignId, getCurrentCampaignElement);
            sendCampaignToDataLayer(campaignId, campaignName);
        }
    });
    $('.js-interest-collection-submit').one('click', function (e) {
        e.preventDefault();
        var currentReadMore = $(e.target);
        var interestCollectionId = Number(currentReadMore.attr('data-id'));
        var getCurrentInterestCollectionElement = $('#campaign-base-' + interestCollectionId);
        if (!isNaN(interestCollectionId)) {
            setInterestCollectionToAdded(getCurrentInterestCollectionElement);
            registerCampaignForUser(interestCollectionId, getCurrentInterestCollectionElement);
        }
    });
    $($('.campaign-base__mail-info__link.ts-send-new-campaign-mail')).click(function () {
        sendNewEmail(event.target);
    });
    function sendNewEmail(element) {
        var parent = element.parentElement;
        $.post({
            url: '/kampanjer/skicka-nytt-mail',
            data: {
                campaignId: $(parent).find('.campaign-base__mail-info__link.ts-send-new-campaign-mail').data('id'),
            },
            success: function () {
                $(parent).find('.campaign-base__mail-info_date-sent').text(getTodaysDate());
                $(parent).find('.campaign-base__mail-info__text').addClass('highlight-campaign-info-text');
            },
            error: function () {
                $(parent).find('.campaign-base__mail-info__text').text('Något gick fel när email skulle skickas.');
            }
        });
    }
    function getTodaysDate() {
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var output = d.getFullYear() + '-' +
            (month < 10 ? '0' : '') + month + '-' +
            (day < 10 ? '0' : '') + day;
        return output;
    }
});
